import { FormControl, Select, Chip } from '@mui/material'
import { styled } from '@mui/system'

const Root = styled('div')({
  margin: 0,
  padding: 0,
})

const FormControlStyle = styled(FormControl)({
  width: '100%',
})

const SelectStyle = styled(Select)({
  background: 'rgba(50, 50, 50, 0.8)',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  borderRadius: '8px',
  textTransform: 'capitalize',
  width: '100%',
  outline: 'none',
  color: '#ffffff',

  '&:hover': {
    background: 'rgba(60, 60, 60, 0.8)',
  },

  '&.Mui-focused': {
    background: 'rgba(60, 60, 60, 0.8)',
    boxShadow: '0 0 0 2px rgba(29, 100, 242, 0.2)',
  },

  '.MuiSelect-outlined': {
    margin: 0,
    padding: '10px 20px',
    color: '#ffffff',
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255, 255, 255, 0.3)',
  },

  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#1d64f2',
    borderWidth: '1px',
  },

  '.MuiSvgIcon-root': {
    color: 'rgba(255, 255, 255, 0.7)',
  },
})

const ChipStyle = styled(Chip)({
  borderRadius: '20px',
  background: 'rgba(29, 100, 242, 0.2)',
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  padding: '5px 12px',
  margin: '5px 5px',
  color: '#ffffff',
  float: 'left',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  border: '1px solid rgba(29, 100, 242, 0.3)',

  '& .MuiChip-label': {
    padding: '0 8px',
  },

  '& .MuiChip-deleteIcon': {
    color: 'rgba(255, 255, 255, 0.7)',
    '&:hover': {
      color: '#ffffff',
    },
  },
})

const MultiselectStyle = { Root, FormControlStyle, SelectStyle, ChipStyle }

export default MultiselectStyle
